import React, {useContext} from 'react'
import BaseComponent from '../common/BaseComponent/BaseComponent'
import {_foreach, _hasProperty} from '../common/helpers/HelperFunc'
import PriceVO from '../valueObjects/PriceVO'

const ContextServicePrice = React.createContext({})

/**
 * @class ContextServicePriceProvider
 * @property {{prices:Object<PriceData>}} contextData
 * @property {Function} getForIds За дадени service ID-та връща съответните цени
 *
 */
class ContextServicePriceProvider extends BaseComponent {
	constructor(props) {
		super(props)
		const contextName =
		  typeof this.props.contextName === 'string'
			? this.props.contextName
			: 'contextServicePriceProvider'
		this.componentName = SHVO.pageState.componentData[contextName].componentName
		this.componentToken =
		  SHVO.pageState.componentData[contextName].componentToken

		this.state = {
			contextData: SHVO.pageState.componentData[contextName].componentData,
			getForIds: this.getForIds,
			getForId: this.getForId,
			getVOForId: this.getVOForId,
			getVOForIdAndTerm: this.getVOForIdAndTerm
		}
	}

	/**
	 * За дадени service ID-та връща съответните цени
	 * @param {Array<string>} serviceIds
	 * @returns {Object<PriceData>}
	 */
	getForIds = (serviceIds) => {
		if (serviceIds.length === 0) {
			return {}
		}

		let data = {}
		serviceIds.map((serviceId) => {
			if (!!this.state.contextData?.prices && !!this.state.contextData?.prices[serviceId]) {
				data = {...data, [serviceId]: this.state.contextData.prices[serviceId]}
			}
		})

		return data
	}

	/**
	 * За дадено service ID връща съответните цени
	 * @param {string} serviceId
	 * @returns {Object<PriceData>}
	 */
	getForId = (serviceId) => {
		return {...this.state.contextData.prices[serviceId]}
	}

	/**
	 * За дадено service ID връща съответните цени
	 * @param {string} serviceId
	 * @returns {Array.<PriceVO>}
	 */
	getVOForId = (serviceId) => {
		const arrPrices = []
		if (_hasProperty(this.state.contextData.prices, serviceId)) {
			_foreach(this.state.contextData.prices[serviceId], (_index, prices) => {
				arrPrices.push(new PriceVO(prices))
			})
		}
		return arrPrices
	}

	/**
	 * @param {string} serviceId
	 * @param {string} term
	 * @returns {PriceVO}
	 */
	getVOForIdAndTerm = (serviceId, term) => {
		let priceData = {}
		if (_hasProperty(this.state.contextData.prices, serviceId)) {
			if (_hasProperty(this.state.contextData.prices[serviceId], term)) {
				priceData = this.state.contextData.prices[serviceId][term]
			}
		}
		return new PriceVO(priceData);
	}

	render() {
		return (
		  <ContextServicePrice.Provider value={this.state}>
			  {this.props.children}
		  </ContextServicePrice.Provider>
		)
	}
}

export {ContextServicePrice, ContextServicePriceProvider}

/**
 *
 * @returns {ContextServicePriceProvider}
 */
export const useServicePriceContext = () => useContext(ContextServicePrice);

/**
 * @typedef {Object} PriceData
 * @property {string} id - идентификатор на цената.
 * @property {string} priceNew - Цена за нова услуга.
 * @property {string} priceNewFormatted - Цена за нова услуга. Форматиран с валутата.
 * @property {number} basePriceNew - Базова цена за нова услуга
 * @property {string} priceRenew - priceRew за подновяване на услуга.
 * @property {string} priceRenewFormatted - priceRew за подновяване на услуга. Форматиран с валутата.
 * @property {number} basePriceRenew - Базова цена за подновяване на услуга
 * @property {string} term - Форматирано описание на период
 * @property {string} termEn - Форматирано описание на период АЕ
 * @property {string} currency - Валута
 * @property {number} discount - Закгръглена стойност на отстъпката
 * @property {number} discount_sum - Закгръглена стойност на отстъпката изчислена. Пример 50 лв.
 * @property {number} isPremium - Дали е премиум цена
 */